import useStore from '../store/useStore';
export default function useSchoolId() {
  const user = useStore(s => s.user);
  const settings = useStore(s => s.settings);
  return user?.schoolId || settings?.schoolId || window._schoolId || null;
}
